import { Component, Input, OnInit } from '@angular/core'
import { ThemePalette } from '@angular/material/core'
import { MatButton } from '@angular/material/button'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'raised-button',
	templateUrl: './RaisedButton.Component.html',
	imports: [MatButton, NgStyle],
})
export class RaisedButtonComponent implements OnInit {
	@Input() public styles: { [name: string]: number | string } = {}

	@Input() public color: ThemePalette

	@Input() public disabled: boolean

	public ngOnInit(): void {
		if (typeof this.styles.margin === 'undefined') {
			this.styles['margin'] = '5px 0 0 0'
		}
	}
}
